import React, { useEffect, useState } from 'react';
import { NextPageContext } from 'next';
import Head from 'next/head';

import { LocationCard } from '../../../components';
import { useSiteQuery } from '../../../hooks';
import { sortLocations } from '../../../lib/Distance';
import ErrorPage from '../../_error';

import Page from '../../[...all]';
import query from './index.graphql';

interface Props {
  uri: string;
  search: string;
}

const renderCard = (item: LocationWithDistance) => {
  if (item?.location) {
    return <LocationCard key={item.location.uid!} item={item.location} />;
  }

  return null;
};

const NursingHomesLocations = ({ uri, search }: Props) => {
  const [{ data, error }] = useSiteQuery<HomesLocationsQuery>({ query });
  const [ordered, setOrdered] = useState<LocationWithDistance[]>([]);

  useEffect(() => {
    async function getSort() {
      if (data?.homesLocations) {
        const homesLocations: NursingHomeLocationFragment[] = data.homesLocations.map(
          (item) => item as NursingHomeLocationFragment,
        );
        const response = await sortLocations(homesLocations, search);
        setOrdered(response);
      }
    }
    getSort();
  }, [data, search]);

  if (error) {
    return <ErrorPage statusCode={500} err={error} />;
  }

  return (
    <>
      <Head>
        <script
          src={`https://maps.googleapis.com/maps/api/js?key=${
            process.env.NEXT_PUBLIC_GOOGLE_API_KEY || ''
          }&libraries=places`}
        />
      </Head>
      <Page uri={uri}>
        <div className="section">
          <div className="container">
            <div className="row">{ordered.map((item) => renderCard(item))}</div>
          </div>
        </div>
      </Page>
    </>
  );
};

NursingHomesLocations.getInitialProps = ({ req, query: { q } }: NextPageContext) => ({
  uri: req?.url?.replace(/^\//, '').replace(/\?.*$/, '') || '404',
  search: q! || '',
});

export default NursingHomesLocations;
